import { z } from 'zod';

/**
 * Énumérations métier partagées par l'API, l'UI et `packages/core` (mêmes valeurs que les enums
 * Postgres de `data-model.md`). Définies une seule fois ici ; `core` les ré-exporte sous ses noms
 * historiques (`IntentSchema`, `ProductTypeSchema`, `ScoreAxisSchema`).
 */

export const INTENT_VALUES = [
  'task',
  'tool',
  'comparison',
  'purchase',
  'informational',
  'navigational',
  'mixed',
] as const;
export const Intent = z.enum(INTENT_VALUES);
export type Intent = z.infer<typeof Intent>;

export const PRODUCT_TYPE_VALUES = [
  'web_app',
  'browser_extension',
  'api',
  'mobile_app',
  'none',
] as const;
export const ProductType = z.enum(PRODUCT_TYPE_VALUES);
export type ProductType = z.infer<typeof ProductType>;

/** Axes A–G du score d'attractivité (`scoring.md` § 4). */
export const SCORE_AXES = ['A', 'B', 'C', 'D', 'E', 'F', 'G'] as const;
export const ScoreAxis = z.enum(SCORE_AXES);
export type ScoreAxis = z.infer<typeof ScoreAxis>;
